import React, { Component } from "react";
import Element from "./element/element";
import "./question.css";
class Question extends Component {
    state = {
        className: "test-to-show",
        automaticAnswer: false,
        elemClassName: "letter-container sixth-test",
        element: null,
        attributes: null
    };

    returnFirstElement = (
        pirveliaso,
        pirvelgilak,
        meoreiaso,
        meoregilak,
        type
    ) => {
        let elementToShow = {};
        let number = Math.floor(Math.random() * 2);
        if (number === 0) {
            elementToShow.char = pirveliaso;
            elementToShow.realAnswer = pirvelgilak;
        } else {
            elementToShow.char = meoreiaso;
            elementToShow.realAnswer = meoregilak;
        }
        elementToShow.type = type;
        return elementToShow;
    };

    returnSecondElement = (
        mesameaso,
        mesamegilak,
        meotxeaso,
        meotxegilak,
        type
    ) => {
        let elementToShow = {};
        let number = Math.floor(Math.random() * 2);
        if (number === 0) {
            elementToShow.char = mesameaso;
            elementToShow.realAnswer = mesamegilak;
        } else {
            elementToShow.char = meotxeaso;
            elementToShow.realAnswer = meotxegilak;
        }
        elementToShow.type = type;
        return elementToShow;
    };

    returnThirdElement = (
        pirveliaso,
        pirvelgilak,
        meoreiaso,
        meoregilak,
        mesameaso,
        mesamegilak,
        meotxeaso,
        meotxegilak,
        type
    ) => {
        let elementToShow = {};
        let number = Math.floor(Math.random() * 4);
        if (number === 0) {
            elementToShow.char = pirveliaso;
            elementToShow.realAnswer = pirvelgilak;
        }
        if (number === 1) {
            elementToShow.char = meoreiaso;
            elementToShow.realAnswer = meoregilak;
        }

        if (number === 2) {
            elementToShow.char = mesameaso;
            elementToShow.realAnswer = mesamegilak;
        }
        if (number === 3) {
            elementToShow.char = meotxeaso;
            elementToShow.realAnswer = meotxegilak;
        }
        elementToShow.type = type;
        return elementToShow;
    };

    returnElementByType = attributes => {
        // console.log(attributes);
        // console.log(attributes);

        const {
            type,
            pirveliaso,
            pirvelgilak,
            meoreiaso,
            meoregilak,
            mesameaso,
            mesamegilak,
            meotxeaso,
            meotxegilak
        } = { ...attributes };
        switch (type) {
            case "type1":
                return this.returnFirstElement(
                    pirveliaso,
                    pirvelgilak,
                    meoreiaso,
                    meoregilak,
                    "type1"
                );
            case "type2":
                return this.returnSecondElement(
                    mesameaso,
                    mesamegilak,
                    meotxeaso,
                    meotxegilak,
                    "type2"
                );
            case "type3":
                return this.returnThirdElement(
                    pirveliaso,
                    pirvelgilak,
                    meoreiaso,
                    meoregilak,
                    mesameaso,
                    mesamegilak,
                    meotxeaso,
                    meotxegilak,
                    "type3"
                );
        }
    };

    componentDidMount() {
        // const userAnswers = this.props.userAnswers;
        // console.log('mounted');
        const timeOut = this.props.timeOut;
        const timetoShow = this.props.timetoShow;
        console.log(timetoShow);
        setTimeout(() => {
            let elemClassName = this.state.elemClassName;
            elemClassName += " hidden";
            this.setState({ elemClassName });
        }, timetoShow);

        let automaticAnswer = this.state.automaticAnswer;
        setTimeout(() => {
            automaticAnswer = true;
            this.setState({ automaticAnswer });
        }, timeOut);

        const { quest } = { ...this.props };
        let attributes = {};
        attributes.pirveliaso = quest.question.pirveliaso;
        attributes.pirvelgilak = quest.question.pirvelgilak;
        attributes.meoreiaso = quest.question.meoreiaso;
        attributes.meoregilak = quest.question.meoregilak;
        attributes.mesameaso = quest.question.mesameaso;
        attributes.mesamegilak = quest.question.mesamegilak;
        attributes.meotxeaso = quest.question.meotxeaso;
        attributes.meotxegilak = quest.question.meotxegilak;
        attributes.type = quest.type;

        let element = this.returnElementByType(attributes);
        this.setState({ element });
        this.setState({ attributes });
    }

    updateAutomatic = () => {
        let automaticAnswer = true;
        this.setState({ automaticAnswer });
    };

    updatesChild = () => {
        let updateChild = this.state.updateChild;
        updateChild = false;
        this.setState({ updateChild });
    };

    render() {
        const { timeOut } = { ...this.props };
        console.log(this.props.quest);

        let startTime = new Date();
        const automaticAnswer = this.state.automaticAnswer;
        return (
            <div className="test-to-show">
                <div className={this.state.elemClassName}>
                    <Element
                        attributes={this.state.attributes}
                        startTime={startTime}
                        timeOut={timeOut}
                        automaticAnswer={automaticAnswer}
                        fillAnswer={this.props.fillAnswer}
                        updateChild={this.state.updateChild}
                        updatesChild={this.updatesChild}
                        element={this.state.element}
                    />
                </div>
            </div>
        );
    }
}

export default Question;
